import { CheckCircle, Clock, FileText, FileX, XCircle } from "lucide-react";

export const getStatusConfig = (status: string) => {
  switch (status) {
    case "paid":
      return {
        variant: "default" as const,
        className:
          "border-green-200 text-green-800 bg-green-50 dark:border-green-800 dark:text-green-200 dark:bg-green-950/20",
        icon: CheckCircle,
        color: "text-green-600",
      };
    case "unpaid":
      return {
        variant: "destructive" as const,
        className:
          "border-red-200 text-red-800 bg-red-50 dark:border-red-800 dark:text-red-200 dark:bg-red-950/20",
        icon: Clock,
        color: "text-red-600",
      };
    case "void":
      return {
        variant: "secondary" as const,
        className:
          "border-gray-200 text-gray-800 bg-gray-50 dark:border-gray-800 dark:text-gray-200 dark:bg-gray-950/20",
        icon: XCircle,
        color: "text-gray-600",
      };
    case "draft":
      return {
        variant: "outline" as const,
        className:
          "border-orange-200 text-orange-800 bg-orange-50 dark:border-orange-800 dark:text-orange-200 dark:bg-orange-950/20",
        icon: FileX,
        color: "text-orange-600",
      };
    case "issued":
    case "synced":
      return {
        variant: "secondary" as const,
        className:
          "border-blue-200 text-blue-800 bg-blue-50 dark:border-blue-800 dark:text-blue-200 dark:bg-blue-950/20",
        icon: FileText,
        color: "text-blue-600",
      };
    default:
      return {
        variant: "secondary" as const,
        className: "",
        icon: FileText,
        color: "text-muted-foreground",
      };
  }
};
